import client from './client';

export const status         = ()        => client.get('/gdrive/status').then(r => r.data);
export const getAuthUrl     = ()        => client.get('/gdrive/auth').then(r => r.data);
// Google Picker でフォルダ選択するため、短命アクセストークンを backend から取得
export const getAccessToken = ()        => client.get('/gdrive/access-token').then(r => r.data);
export const sort           = (payload) => client.post('/gdrive/sort', payload).then(r => r.data);
